import { Link, Outlet, useLocation } from 'react-router-dom';
import { BookOpen, UserRound } from 'lucide-react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { cn } from '@/utils/cn';

const sidebarItems = [
  { label: 'My Courses', path: '/tutor/courses', icon: BookOpen },
  { label: 'My Tutor Profile', path: '/tutor/profile', icon: UserRound },
];

export const TutorLayout = () => {
  const location = useLocation();

  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <div className="flex h-full min-h-0 flex-col overflow-hidden">
          <div className="sticky top-0 z-30 border-b border-slate-200 bg-white md:hidden">
            <nav className="flex items-center gap-2 overflow-x-auto px-4 py-3 scrollbar-thin">
              {sidebarItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={cn(
                      'inline-flex items-center gap-2 whitespace-nowrap rounded-lg border px-3 py-2 text-sm font-semibold transition',
                      isActive
                        ? 'border-[rgb(var(--accent-solid))/0.30] bg-[rgb(var(--accent-solid))/0.10] text-[rgb(var(--accent-solid))]'
                        : 'border-slate-200 text-slate-700 hover:border-slate-300 hover:bg-slate-50'
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="flex min-h-0 flex-1">
            <Sidebar items={sidebarItems} />
            <section className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 lg:p-8">
              <Outlet />
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};
